import {
  UPDATE_FINANCIALS_START,
  UPDATE_FINANCIALS_SUCCESS,
  UPDATE_FINANCIALS_FAILURE,
} from './types';

export const updateFinancialsStart = (payload) => ({
  type: UPDATE_FINANCIALS_START,
  payload: payload,
})

export const updateFinancialsSuccess = (payload) => ({
  type: UPDATE_FINANCIALS_SUCCESS,
  payload: payload,
})

export const updateFinancialsFailure = (payload) => ({
  type: UPDATE_FINANCIALS_FAILURE,
  payload: payload,
})
